import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';  
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from '../login/keycloak.service';
import {GlobalsService} from '../_services/globals.service'; 
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GraphviewService 
{
    private graphdata: ReplaySubject<any> = new ReplaySubject<any>();
    private $graphdataObservable:Observable<any>;
    constructor( private http: HttpClient ,private kks:KeycloakService ,private gs:GlobalsService ) 
    {

        this.graphdata = new ReplaySubject<any>(1);
        this.$graphdataObservable = this.graphdata.asObservable();
    }

    public  setData( data:any , type:string , title:string , graphrequestdata:any)
    {
        this.graphdata.next({data:data,type:type,title:title,requestdata:graphrequestdata});
    }
    
    public getGraphData(body: string): Observable<any> {

        return this.http
            .post<any>(
            this.gs.getRestUrl() + '/api/charts/getChartData',
            body,
            )
            .pipe(
            catchError(error =>
                throwError(() => new Error(String(error?.status)))
            )
            );
    }

    public subscribe():Observable<any>
    {
        return this.graphdata.asObservable();
    }

    public createDataSet(obj:any[] , labelskey:string , datasetskeys:any[]):any
    {
        let data: {labels: string[], datasets: any[]} = {labels:[],datasets:[]};
        data.labels =  obj.map(r=>""+r[labelskey]);
        datasetskeys.forEach(k=>{
            var dsp = {borderColor:k.color,backgroundColor:k.color , fill:k.fill , label:k.label+"",data:obj.map(r=>this.toNumber( r[k.label] ) )};
            dsp.label = dsp.label.replace(new RegExp("_", 'g') ," ");
            data.datasets.push(dsp);
        });
        return data;

    }

    public getCsvData(body: string): Observable<string> {
        return this.http
            .post(this.gs.getRestUrl() + '/api/charts/getCsvData', body, {
            responseType: 'text' as const
            })
            .pipe(
            catchError(error =>
                throwError(() => new Error(String(error?.status)))
            )
            );
    }

    private toNumber(data:any)
    {  
      if (data != null)
      {    
          
          data =  data.toString().replace(new RegExp(/\./, 'g'),"");
          data =  data.toString().replace(new RegExp(/,/, 'g'),".");//replace decimals
          
          var n = Number(data);
          if ( !isNaN(n))
          {
             return n;
          }
       
          return data;
      }
      return data;
    }

}
